import { Component, OnInit } from '@angular/core';
import { IPlayer } from '../../models/player';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-create-player',
  templateUrl: './create-player.component.html',
  styleUrls: ['./create-player.component.css']
})
export class CreatePlayerComponent implements OnInit {
  player: IPlayer = {
    firstName: '',
    lastName: '',
    team: '',
    position: '',
    byeWeek: '',
    lastYearPoints: 0,
    projectedPoints: 0,
    highestBid: null
  };
  uploadText = '';
  positions = ['QB', 'RB', 'WR', 'TE', 'D/ST'];
  constructor(private db: AngularFirestore) {}

  ngOnInit() {}

  createSet() {
    const uploadJson = JSON.parse(this.uploadText);
    uploadJson.forEach(element => {
      this.create(element);
    });
  }

  createOne() {
    if (
      this.player.firstName &&
      this.player.lastName &&
      this.player.team &&
      this.player.position &&
      this.player.byeWeek
    ) {
      this.create(this.player);
      this.player = {
        firstName: '',
        lastName: '',
        team: '',
        position: '',
        byeWeek: '',
        lastYearPoints: 0,
        projectedPoints: 0,
        highestBid: null
      };
    }
  }

  create(player) {
    this.db
      .collection('players')
      .doc(player.firstName + player.lastName + player.team)
      .set(player);
  }
}
